// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';

// COMPONENTS
import MoneyInput from 'components/inputs/MoneyInput';
import Button from 'components/common/Button';

const FormItem = Form.Item;
const { TextArea } = Input;

// add plan _id
// add dashboards

// This component only renders the LineItems form, all the logic must be handled
// in the parent component.
class LineItemForm extends React.Component {
  handleSubmit = evt => {
    const {
      onBeforeHook, onErrorHook, onSubmitHook, form,
    } = this.props;

    evt.preventDefault();

    // Run before logic if provided and return on error
    try {
      onBeforeHook();
    } catch (exc) {
      return; // return silently
    }

    form.validateFields((err, lineItem) => {
      if (err) {
        // Pass event up to parent component
        onErrorHook(err);
      } else {
        // Clean amount. Replace any occurrence of , or . with whitespace
        const amount = lineItem.amount.replace(/[,.]+/g, '');
        // Pass lineItem values to parent component to handle submit functionality
        onSubmitHook(Object.assign({}, lineItem, { amount }));
      }
    });
  };

  render() {
    const {
      form, btnLabel, initialValue, disabled,
    } = this.props;
    const { getFieldDecorator } = form;

    return (
      <div
        className="form-container"
        style={{
          minHeight: '380px',
          width: '400px',
          maxWidth: '100%',
          margin: 'auto',
        }}
      >
        <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <FormItem label="Package Name" hasFeedback>
            {getFieldDecorator('title', {
              initialValue: (initialValue && initialValue.title) || null,
              validateTrigger: 'onBlur',
              rules: [
                { required: true, message: 'Please input a Package Name!' },
                { max: 70, message: 'Must be no more than 70 characters!' },
              ],
            })(<Input size="large" placeholder="title..." />)}
          </FormItem>
          <FormItem label="Amount" hasFeedback>
            {getFieldDecorator('amount', {
              initialValue: (initialValue && (initialValue.amount / 100).toFixed(2)) || null,
              validateTrigger: 'onBlur',
              rules: [
                { required: true, message: 'Please input a Amount!' },
                { max: 70, message: 'Must be no more than 70 characters!' },
              ],
            })(<MoneyInput currencySymbol={this.props.currencySymbol} placeholder="Amount..." />)}
          </FormItem>
          <FormItem label="Description:" hasFeedback>
            {getFieldDecorator('description', {
              initialValue: (initialValue && initialValue.description) || null,
              validateTrigger: 'onBlur',
              rules: [
                { required: true, message: 'Please input a description!' },
                { max: 7500, message: 'Must be no more than 7500 characters!' },
              ],
            })(<TextArea rows={5} />)}
          </FormItem>
          <Button
            htmlType="submit"
            type="primary"
            disabled={disabled}
            loading={disabled}
            size="large"
            style={{ marginLeft: 8 }}
          >
            {btnLabel}
          </Button>
        </Form>
      </div>
    );
  }
}

LineItemForm.propTypes = {
  // type: PropTypes.oneOf(['new', 'edit']).isRequired,
  btnLabel: PropTypes.string,
  initialValue: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.string,
    description: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  onBeforeHook: PropTypes.func,
  onErrorHook: PropTypes.func,
  onSubmitHook: PropTypes.func,
  // onCancel: PropTypes.func,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

LineItemForm.defaultProps = {
  btnLabel: 'SUBMIT',
  initialValue: null,
  disabled: false,
  onBeforeHook: () => {},
  onErrorHook: () => {},
  onSubmitHook: () => {},
  // onCancel: () => {},
};

export default Form.create()(LineItemForm);



// WEBPACK FOOTER //
// ./src/routes/app-studio/PricingAndPackagingArea/LineItemFormLegacy/index.js